angular.module('vastdesk')
.component('copyButton', {
  bindings: {
    copyTarget: '@',
    copyButtonClass: '@',
    copyButtonText: '@'
  },
  template: '<button class="btn {{$copyCtrl.copyButtonClass}}" type="button" ng-bind-html="$copyCtrl.copyButtonContent"></button>',
  controllerAs: '$copyCtrl',
  controller: ['$element', function($element) {

    var self = this;

    this.$onInit = function() {
      self.copyButtonClass = self.copyButtonClass || 'btn-ss-submit';
      self.copyButtonText = self.copyButtonText || 'Copy';
      self.copyButtonContent = '<i class="far fa-clipboard"></i>' + self.copyButtonText;
    };

    function textToCopy() {
      var $target = $(self.copyTarget);
      if ($target.is('input, textarea')) {
        return $target.val() || '';
      }
      return $target.text() || '';
    }

    function showCopySuccessPopover() {
      $element.popover({
        animation: true,
        placement: 'top',
        content: '<i class="fa fa-check-square text-success"></i>',
        sanitize: false,
        trigger: 'manual',
        html: true,
        delay: {
          hide: 100
        }
      }).popover('show');

      setTimeout(function () {
        $element.popover('hide');
      }, 500);
    }

    function copyWithExecCommand() {
      var $target = $(self.copyTarget);
      $target.select();
      return document.execCommand('copy');
    }

    $element.on('click', function() {
      if (!self.copyTarget || self.copyTarget === '') {
        return;
      }

      var text = textToCopy();
      if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
        navigator.clipboard.writeText(text)
          .then(showCopySuccessPopover)
          .catch(function () {
            //fallback to execCommand if Clipboard API fails
            if (copyWithExecCommand()) {
              showCopySuccessPopover();
            }
          });
      } else if (copyWithExecCommand()) {
         //fallback to execCommand if clipboard is not supported
        showCopySuccessPopover();
      }
    });

  }]
});
